// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__WhatPage__incidentIndication{align-items:normal}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-fnol-cp-react/pages/What/WhatPage.module.scss"],"names":[],"mappings":"AAAA,mCACI,kBAAA","sourcesContent":[".incidentIndication {\n    align-items: normal; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"incidentIndication": "app__WhatPage__incidentIndication"
};
export default ___CSS_LOADER_EXPORT___;
